/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/partials/page-title.module.scss';

const propTypes = {
    title: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    className: null,
};

const PageTitle = ({ title, className }) => {
    const isLong = typeof title === 'string' && title.length > 50;
    return (
        <div
            className={classNames(styles.container, {
                [className]: className !== null,
                [styles.isLong]: isLong,
            })}
        >
            {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
        </div>
    );
};

PageTitle.propTypes = propTypes;
PageTitle.defaultProps = defaultProps;

export default PageTitle;
